export enum ConsumptionDataColorEnum {
    DATA = "#3EAADF",
    CALL = "#F1911F",
    SMS = "#fdcb47",
    NEUTRE = "#E7EEF0"
}